var _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 4.5,
    strokeDasharray: "2 2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.715 13.878a.3.3 0 01.571 0l.545 1.678a.3.3 0 00.285.207h1.765a.3.3 0 01.176.543l-1.428 1.037a.3.3 0 00-.109.335l.545 1.679a.3.3 0 01-.462.335l-1.428-1.037a.3.3 0 00-.353 0l-1.428 1.037a.3.3 0 01-.462-.335l.545-1.679a.3.3 0 00-.109-.335L4.94 16.306a.3.3 0 01.176-.543h1.765a.3.3 0 00.285-.207l.545-1.678z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18H22v4H12M14 14h7v4h-6.5M8 10h14v4h-8.5M7 6h14v4H7zM9 2h14v4H9z"
  }))));
}
SvgStack.displayName = 'Stack';
export default SvgStack;